import type {ReactAction} from '@netx/core/bootstrap';
import {performLegacyAction} from '@netx/core-next/utils/actions';
import {faSignOut} from '@netx/core-icons';
import {UserActionLabel} from '../locales';
import {canLogout} from '../enablers';

export const userActionLogoutIcon = faSignOut;

/**
 * Route to user logout
 * @param params
 * @returns Action
 */
export const userActionLogout = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-logout',
	cb: () => performLegacyAction('app:logout'),
	enableTest: () => canLogout(),
	icon: userActionLogoutIcon,
	get label() {
		return UserActionLabel.LOGOUT;
	},
	...params,
});

export default userActionLogout;
